/**
 * Application validators - Duty application related types
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Application Status
// ============================================================================

export const applicationStatusValidator = v.union(
  v.literal('pending_verification'),
  v.literal('pending'),
  v.literal('accepted'),
  v.literal('rejected'),
  v.literal('expired'),
  v.literal('withdrawn')
);

export type ApplicationStatus = Infer<typeof applicationStatusValidator>;

export const APPLICATION_STATUSES = [
  'pending_verification',
  'pending',
  'accepted',
  'rejected',
  'expired',
  'withdrawn',
] as const;

// ============================================================================
// Application Validity Days
// ============================================================================

// Stored validity: legacy Applications may still carry 7 days (unset also reads as 7).
export const applicationValidityDaysValidator = v.union(
  v.literal(7),
  v.literal(14),
  v.literal(30)
);

export type ApplicationValidityDays = Infer<typeof applicationValidityDaysValidator>;

export const APPLICATION_VALIDITY_DAYS = [7, 14, 30] as const;

// Choosable validity: what a Substitute can pick when applying, reapplying or extending.
export const choosableApplicationValidityDaysValidator = v.union(v.literal(14), v.literal(30));

export type ChoosableApplicationValidityDays = Infer<typeof choosableApplicationValidityDaysValidator>;

export const CHOOSABLE_APPLICATION_VALIDITY_DAYS = [14, 30] as const;

export const DEFAULT_APPLICATION_VALIDITY_DAYS: ChoosableApplicationValidityDays = 14;

// ============================================================================
// Application Activity Action Type
// ============================================================================

export const applicationActivityActionValidator = v.union(
  v.literal('created'),
  v.literal('price_changed'),
  v.literal('validity_extended'),
  v.literal('withdrawn'),
  v.literal('renewed'),
  v.literal('renewal_requested')
);

export type ApplicationActivityAction = Infer<typeof applicationActivityActionValidator>;

export const APPLICATION_ACTIVITY_ACTIONS = [
  'created',
  'price_changed',
  'validity_extended',
  'withdrawn',
  'renewed',
  'renewal_requested',
] as const;
